export const SEARCH_REQUEST = 'SEARCH_REQUEST';

export const search = (query, type = 'all', callback, { from, limit } = {}) => ({
    type: SEARCH_REQUEST,
    payload: { query, type, from, limit, callback },
});
